module.exports = __webpack_public_path__ + "static/playstore-button-85749d69e3adb32907faa49e6f04f3f9.png";